<template>
  <div class="max-w-full truncate text-gray-900 md:text-2xl">
    <slot />
  </div>
</template>
